import dayjs from "dayjs";
import {
  CouponDiscountType,
  CouponPurchaseCondition,
  CouponScope,
  MAX_COUPON_PRODUCTS,
} from "../constants/coupons.constants";
import { CouponDraft, CouponFormValidation } from "../entities/coupon.entity";

export const createEmptyCouponDraft = (): CouponDraft => ({
  offerName: "",
  offerCode: "",
  discountType: CouponDiscountType.Percentage,
  discountValue: undefined,
  enabled: true,
  canBeUpdated: true,
  hasSchedule: false,
  hasUsageLimit: false,
  maxUsages: 0,
  scope: CouponScope.Store,
  productIds: [],
  products: [],
  purchaseCondition: CouponPurchaseCondition.None,
  minPurchaseValue: undefined,
  startsAt: undefined,
  endsAt: undefined,
  orderOffers: [],
});

export const validateCouponDraft = (
  draft: CouponDraft
): CouponFormValidation => {
  const isValidName = Boolean(draft.offerName?.trim());
  const discountValue = Number(draft.discountValue);
  const isValidDiscount =
    Number.isFinite(discountValue) &&
    discountValue > 0 &&
    (draft.discountType !== CouponDiscountType.Percentage ||
      discountValue <= 100);

  const isValidScope =
    draft.scope === CouponScope.Store ||
    Boolean(
      draft.productIds?.length &&
        draft.productIds.length <= MAX_COUPON_PRODUCTS
    );

  let isValidDates = true;
  if (draft.hasSchedule) {
    if (!draft.startsAt || !draft.endsAt) {
      isValidDates = false;
    } else {
      const start = dayjs(draft.startsAt);
      const end = dayjs(draft.endsAt);
      isValidDates = end.isAfter(start) || end.isSame(start, "day");
    }
  }

  const isValidUsageLimit = draft.hasUsageLimit
    ? Number(draft.maxUsages) > 0
    : true;

  let isValidPurchaseCondition = true;
  if (draft.purchaseCondition === CouponPurchaseCondition.MinPurchase) {
    isValidPurchaseCondition = Number(draft.minPurchaseValue) > 0;
  }

  const isValid =
    isValidName &&
    isValidDiscount &&
    isValidScope &&
    isValidDates &&
    isValidUsageLimit &&
    isValidPurchaseCondition;

  return {
    isValidName,
    isValidDiscount,
    isValidScope,
    isValidDates,
    isValidUsageLimit,
    isValidPurchaseCondition,
    isValid,
  };
};
